<template>
    <div>
        <div v-if="loading" class="loading"/>

        <div>
            <b-row class="h-100">
                <b-colxx xxs="9">
                    <b-card class="mb-5 invoice-header-contents" no-body>
                        <b-card-body v-text="breadcrumb">Daily Signatures Report > All Facility</b-card-body>
                    </b-card>
                    <b-card no-body>
                        <b-card-body class="d-flex flex-column justify-content-between">
                            <div class="d-flex flex-column" v-if="reportData.data.length > 0">
                                <div class="d-flex flex-row justify-content-between mb-5">
                                    <div class="d-flex flex-column w-70 mr-2 p-4 text-semi-muted bg-semi-muted">
                                        <h2>{{ reportData.title }}</h2>
                                        <h3>{{ reportData.subtitle }}</h3>
                                        <p class="mb-0" v-if="responseReportFacilityType === 'All Facilities' && reportData.vendor_manager">Vendor Manager: {{ reportData.vendor_manager }} </p>
                                        <p class="mb-0" v-if="responseReportType === 'Daily Signature Report'">Report Date: {{ reportData.report_date }} </p>
                                        <p class="mb-0" v-if="responseReportType === 'Monthly Signature Report'">Report Period: {{ reportData.report_period }}</p>
                                        <p class="mb-0" v-if="responseReportFacilityType === 'Single Facility'">Facility: {{ reportData.facility }} </p>
                                        <p class="mb-0" v-if="responseReportFacilityType === 'Single Facility'">Address: {{ reportData.address }} </p>
                                    </div>

                                    <div class="d-flex w-30 flex-column text-right p-4 text-semi-muted bg-semi-muted">
                                        <p class="mb-0" v-if="responseReportFacilityType === 'All Facilities'">Total Facility: {{ reportData.data.length }} </p>
                                        <p class="mb-0">Total Occupied: {{ reportData.total_occupied_units }}</p>
                                        <p class="mb-0">Total Signs Recieved: {{ reportData.total_signed_received }}</p>
                                        <p class="mb-0">Total Sign Missing: {{ reportData.total_sign_missing }}</p>
                                        <p class="mb-0">% of Sign Collected: {{ reportData.sign_percentage }}%</p>
                                        <p class="mb-0" v-if="responseReportFacilityType === 'All Facilities'">Total Attachment Missing: {{ reportData.total_sheet_missing }}</p>
                                    </div>
                                </div>
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th class="text-muted mb-2" v-if="responseReportFacilityType === 'All Facilities'">VENDOR</th>
                                        <th class="text-muted mb-2" v-if="responseReportFacilityType === 'All Facilities'">FACILITY</th>
                                        <th class="text-muted mb-2" v-if="responseReportFacilityType === 'All Facilities'">ADDRESS</th>
                                        <th class="text-muted mb-2" v-if="responseReportFacilityType === 'Single Facility'">Floor</th>
                                        <th class="text-muted mb-2" v-if="responseReportFacilityType === 'Single Facility'">Unit</th>
                                        <th class="text-muted mb-2">OCCUPIED</th>
                                        <th class="text-muted mb-2">SIGN RECIEVED</th>
                                        <th class="text-muted mb-2" v-if="responseReportFacilityType === 'All Facilities'">SIGN MISSING</th>
                                        <th class="text-muted mb-2" v-if="responseReportFacilityType === 'All Facilities'">% OF SIGNS</th>
                                        <th class="text-muted mb-2" v-if="responseReportFacilityType === 'All Facilities'">SHEET MISSING</th>
                                        <th class="text-muted mb-2" v-if="responseReportFacilityType === 'All Facilities' && responseReportType === 'Daily Signature Report'">NOTE</th>
                                        <th class="text-muted mb-2" v-if="responseReportFacilityType === 'Single Facility' && responseReportType === 'Daily Signature Report'">Remark</th>
                                        <!-- <th class="text-muted mb-2" v-if="responseReportFacilityType === 'All Facilities'">Attachment</th> -->
                                    </tr>
                                    </thead>

                                    <tbody>
                                    <tr v-for="(data, key) in reportData.data" :key="key">
                                        <td v-if="responseReportFacilityType === 'All Facilities'">{{ data.vendor }}</td>
                                        <td v-if="responseReportFacilityType === 'All Facilities'">{{ data.facility }}</td>
                                        <td v-if="responseReportFacilityType === 'All Facilities'">{{ data.address }}</td>
                                        <td v-if="responseReportFacilityType === 'Single Facility'">{{ data.floor }}</td>
                                        <td v-if="responseReportFacilityType === 'Single Facility'">{{ data.unit }}</td>
                                        <td>{{ data.occupied_units }}</td>
                                        <td>{{ data.total_signed }}</td>
                                        <td v-if="responseReportFacilityType === 'All Facilities'">{{ data.sign_missing }}</td>
                                        <td v-if="responseReportFacilityType === 'All Facilities'">{{ data.sign_percentage }}</td>
                                        <td v-if="responseReportFacilityType === 'All Facilities' && responseReportType === 'Daily Signature Report'" v-text="data.sheet_missing ? 'Yes' : 'No'"></td>
                                        <td v-if="responseReportFacilityType === 'All Facilities' && responseReportType === 'Monthly Signature Report'" v-text="data.sheet_missing"></td>
                                        <td v-if="responseReportFacilityType === 'All Facilities' && responseReportType === 'Daily Signature Report'">{{ data.notes ? data.notes : 'N/a' }}</td>
                                        <td v-if="responseReportFacilityType === 'Single Facility' && responseReportType === 'Daily Signature Report'">{{ data.notes ? data.notes : 'N/a' }}</td>
                                        <!-- <td v-if="responseReportFacilityType === 'All Facilities'">
                                            <template v-if="data.attachment">
                                                <a data-v-67442422="" target="_blank" :href="data.attachment"><i class="glyph-icon iconsminds-download"/></a>
                                            </template>
                                        </td> -->
                                    </tr>
                                    </tbody>
                                </table>

                                <b-row class="mt-4 mb-4" v-if="signatureSheet">

                                    <div data-v-67442422="" class="card d-flex flex-row listing-card-container">

                                    <div data-v-67442422="" class="w-40 position-relative" style="height: 100px;">
                                        <div data-v-67442422="" class="position-relative"><a data-v-67442422="" target="_blank" :href="signatureSheetUrl"><span data-v-67442422="" class="iconsminds-file menu-icon-style card-img-left" style="font-size: 70px; height: 100px;"></span></a></div>
                                    </div>

                                    <div data-v-67442422="" class="w-60 ml-0 d-flex align-items-center">
                                        <div data-v-67442422="" class="card-body" style="padding: 1.2rem;">
                                            <span data-v-67442422="" title="1462-400438283.pdf" class="listing-heading vue-line-clamp" style="-webkit-line-clamp: 1;">
                                            {{ signatureSheet }}
                                            </span>
                                        </div>
                                    </div>
                                    </div>


                                </b-row>
                            </div>

                            <div class="d-flex flex-column" v-else>
                                <b-alert v-if="alertMessage.length > 0" variant="danger" class="p-4 text-center" show>
                                    <h6>{{alertMessage}}</h6>
                                </b-alert>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-colxx>

                <div class="app-menu">
                    <section class="ps-container">
                        <div class="p-4">
                            <b-colxx>
                                <b-row class="text-muted text-small mb-3 text-left mt-1">
                                    <p>Choose options to generate reports</p><br>
                                </b-row>

                                <b-row class="mb-3">
                                    <b-colxx md="12">
                                        <b-form-group label="Select Report Type" class="has-float-label">
                                            <template v-slot:label>
                                                <span>Select Report Type <sup><code>*</code></sup></span>
                                            </template>

                                            <v-select v-model="selected.report" :options="reports"
                                                      :border-danger="'report_type' in errors"/>

                                            <b-form-invalid-feedback :state="!'report_type' in errors"
                                                 v-text="'report_type' in errors ? errors.report_type[0] : ''"/>
                                        </b-form-group>
                                    </b-colxx>
                                </b-row>

                                <b-row class="mb-3" v-if="selected.report.value === 'Daily Signature Report'">
                                    <b-colxx md="12">
                                        <b-form-group label="Date" class="has-float-label">
                                            <template v-slot:label>
                                                <span>Date <sup><code>*</code></sup></span>
                                            </template>

                                            <v-date-picker
                                                popover-visibility="focus"
                                                mode="single"
                                                v-model="datepicker.date"
                                                :input-props="{ class:'form-control' + ('date' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                                            <b-form-invalid-feedback :state="!('date' in errors)"
                                                                    v-text="'date' in errors ? errors.date[0] : ''"/>
                                        </b-form-group>
                                    </b-colxx>
                                </b-row>

                                <b-row class="mb-3" v-if="selected.report.value === 'Monthly Signture Report'" >
                                    <b-colxx md="12">
                                        <b-form-group label="Month" class="has-float-label">
                                            <template v-slot:label>
                                                <span>Month <sup><code>*</code></sup></span>
                                            </template>

                                            <month-picker
                                                @month-changed="updateMonth"
                                                @year-changed="updateYear"
                                                :min-year="today.getFullYear() - 5"
                                                :max-year="today.getFullYear()"
                                            />

                                            <b-form-invalid-feedback :state="!('month' in errors)"
                                                                    v-text="'month' in errors ? errors.month[0] : ''"/>
                                        </b-form-group>
                                    </b-colxx>
                                </b-row>

                                <b-row class="mb-3">
                                    <b-colxx md="12">
                                        <b-form-group label="Option" class="has-float-label">
                                            <template v-slot:label>
                                                <span>Select Facility Type <sup><code>*</code></sup></span>
                                            </template>

                                            <v-select v-model="selected.option" :options="options"
                                                      :border-danger="'facility_type' in errors"/>

                                            <b-form-invalid-feedback :state="!'facility_type' in errors"
                                                 v-text="'facility_type' in errors ? errors.facility_type[0] : ''"/>
                                        </b-form-group>
                                    </b-colxx>
                                </b-row>

                                <b-row class="mb-3" v-if="selected.option.value === 'Single Facility'">
                                    <b-colxx md="12">
                                        <b-form-group label="Facility" class="has-float-label">
                                            <template v-slot:label>
                                                <span>Facility <sup><code>*</code></sup></span>
                                            </template>

                                            <v-select v-model="selected.facility" :options="facilities"
                                                    :border-danger="'facility_id' in errors"/>

                                            <b-form-invalid-feedback :state="!'facility_id' in errors"
                                                                    v-text="'facility_id' in errors ? errors.facility_id[0] : ''"/>
                                        </b-form-group>
                                    </b-colxx>
                                </b-row>

                                <b-row class="mb-3" v-if="selected.option.value === 'All Facilities'">
                                    <b-colxx md="12">
                                        <b-form-group label="Vendor Manager" class="has-float-label">
                                            <template v-slot:label>
                                                <span>Vendor Manager </span>
                                            </template>

                                            <v-select v-model="vendor_manager" :options="vendorManagers"
                                                    :border-danger="'vendor_manager' in errors"/>

                                            <b-form-invalid-feedback :state="!'vendor_manager' in errors"
                                                                    v-text="'vendor_manager' in errors ? errors.vendor_manager[0] : ''"/>
                                        </b-form-group>
                                    </b-colxx>
                                </b-row>

                                <template v-if="selected.option.value === 'All Facilities'">
                                    <b-row class="text-muted text-small mb-1 text-left mt-1">
                                        <p>Categories</p><br>
                                    </b-row>

                                    <b-row class="text-small text-left mt-1">
                                        <b-form-checkbox  id="all"
                                                        v-model="status"
                                                        name="checkbox-1"
                                                        value="all">
                                            All
                                        </b-form-checkbox>
                                    </b-row>
                                    <b-row class="text-small text-left mt-1">
                                        <b-form-checkbox  id="single"
                                                        v-model="status"
                                                        name="checkbox-2"
                                                        value="single">
                                            Single
                                        </b-form-checkbox>
                                    </b-row>

                                    <b-row class="text-small text-left mt-1">
                                        <b-form-checkbox  id="family"
                                                        v-model="status"
                                                        name="checkbox-3"
                                                        value="family">
                                            Family
                                        </b-form-checkbox>
                                    </b-row>
                                </template>


                                <b-button class="mt-lg-5" size="lg" variant="primary" @click="generateReport">
                                    Generate Report
                                </b-button>
                            </b-colxx>
                        </div>
                    </section>
                </div>
            </b-row>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import StateButton from "../../../../components/Common/StateButton";
import MonthPicker from "../../../../components/Monthpicker/MonthPicker";

export default {
    name: "SignaturesReport",

    components: {
        StateButton,
        MonthPicker
    },

    data() {
        return {
            loading: false,
            alertMessage: 'Please generate report',
            reportData: {
                data: [],
            },
            facilities: [],
            selected: {
                facility: { value: null },
                option: { value: null },
                report: [],
                reports: [],
                options: [],
            },
            datepicker: {
                date: new Date(),
                month: (new Date()).getMonth() + 1,
                year: (new Date()).getFullYear()
            },
            reports: [
                {label: 'Daily Signature Report', value: 'Daily Signature Report'},
                {label: 'Monthly Signture Report', value: 'Monthly Signture Report'},
            ],
            options: [
                {label: 'All Facilities', value: 'All Facilities'},
                {label: 'Single Facility', value: 'Single Facility'},
            ],
            status: 'checked',

            today: new Date(),
            form: {
                date: new Date(),
            },
            vendorManagers: [],
            vendor_manager: null,
            breadcrumb: 'Signature Report',
            errors: {},

            responseReportFacilityType: null,
            responseReportType: null,
            signatureSheet: null,
            signatureSheetUrl: null,
        }
    },

    computed: {
        ...mapGetters({
            // errors: 'getSignatureErrors',
            // facilities: 'getSelectFacilities',
        })
    },

    watch: {
        'selected.report': function (newVal, oldVal) {
            this.selected.option = []
            this.errors = []
            this.status = 'checked'
            if (this.selected.report.label) {
                this.breadcrumb = this.selected.report.label
            }
        },
        'selected.option': function (newVal, oldVal) {
            this.errors = []
            this.status = this.selected.option.label === 'All Facilities' ? 'all' : 'checked'
            if (this.selected.option.label) {
                this.breadcrumb = this.selected.report.label + ' > ' + this.selected.option.label
            }

            if (this.selected.option.label === 'All Facilities') {
                this.fetchVendorManager();
            }
        },
        'status': function (newVal, oldVal) {
            if (this.selected.option.label === 'All Facilities') {
                this.breadcrumb = this.selected.report.label + ' > ' + this.selected.option.label + ' > ' + this.capitalizeFirstLetter(this.status)
            }
        },
    },

    mounted() {
        axios.get('/api/hms/select/facilities')
            .then(response => {
                this.facilities = response.data.data
                // response.data.data.map(res => {
                //     console.log(res);
                // })
            });
    },

    methods: {
        fetchVendorManager() {
            axios.get('/api/hms/select/vendor-manager')
                .then(response => {
                    this.vendorManagers = response.data.data
                });
        },

        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },

        updateMonth(field) {
            if (field) {
                this.datepicker.month = field.value;
            }
        },

        updateYear(field) {
            if (field) {
                this.datepicker.year = field.value;
            }
        },

        generateReport() {
            this.errors = [];
            let hasError = false;
            if (this.selected.report.length === 0 || this.selected.report.value === null || this.selected.report.value.length === 0) {
                this.errors.report_type = ['Report type required'];
                hasError = true;
            }

            if (this.selected.report.length != 0 && this.selected.report.value != null && this.selected.report.value === 'Daily Signature Report' && (this.datepicker.date === null || this.datepicker.date === '') ) {
                this.errors.date = ['Please specify a date'];
                hasError = true;
            }

            if (this.selected.report.length != 0 && this.selected.report.value != null && this.selected.report.value === 'Monthly Signature Report' && (this.datepicker.month === null || this.datepicker.month === '') ) {
                this.errors.date = ['Please specify a month and year'];
                hasError = true;
            }

            if (this.selected.option.length === 0 || this.selected.option.value === null || this.selected.option.value.length === 0) {
                this.errors.facility_type = ['Facility type required'];
                hasError = true;
            }


            if (this.selected.option.length != 0 && this.selected.option.value != null && this.selected.option.value === 'Single Facility' && (this.selected.facility.value === null) ) {
                this.errors.facility_id = ['Please select a facility'];
                hasError = true;
            }

            if (hasError === false) {
                this.alertMessage = "Fetching data from server ..."
                this.reportData.data = [];
                let formdata = {};
                if (this.selected.report.value === 'Daily Signature Report' && this.datepicker.date) {
                    formdata.date = this.datepicker.date
                }
                if (this.selected.report.value === 'Monthly Signture Report' && this.datepicker.month) {
                    formdata.month = this.datepicker.year + '-' + this.datepicker.month + '-01'
                }
                if (this.selected.option.value === 'Single Facility' && this.selected.facility.facility_id) {
                    formdata.facility_id = this.selected.facility.facility_id
                }
                if (this.selected.option.value === 'All Facilities' && this.status === 'single') {
                    formdata.single = 1
                }
                if (this.selected.option.value === 'All Facilities' && this.status === 'family') {
                    formdata.family = 1
                }
                if (this.selected.option.value === 'All Facilities' && this.status === 'single') {
                    formdata.single = 1
                }
                if (this.selected.option.value === 'All Facilities' && this.vendor_manager != null) {
                    formdata.vendor_manager = this.vendor_manager.code;
                }
                console.log(formdata)
                axios.post('/api/hms/signatures/reports', formdata)
                    .then(response => {

                        this.reportData = response.data
                        this.responseReportFacilityType = response.data.facility_type
                        this.responseReportType = response.data.report_type
                        if (response.data.signature_sheet) {
                            this.signatureSheet = response.data.signature_sheet;
                            this.signatureSheetUrl = '/storage/attachments/signatures/' + response.data.signature_sheet.split('-')[0] + '/' + response.data.signature_sheet;
                        }
                        if (response.data.data.length === 0) {
                            this.alertMessage = "No data found"
                        }
                    })
            }

        },
    }
}
</script>

<style scoped>
.app-menu {
    width: 400px;
}
</style>
